import { taskServiceTypeDef } from "../definitions/task-service-type-def";
import gql from "graphql-tag";
import { errorsTypeDef } from "../../errors/errors-type-def";

const createMutation = gql`
  mutation createTask (
  $damageCategoryId: String!
  $damageTypeId: String!
  $carVin: String
  $carLicensePlate: String
  $carNonstandardLicensePlate: Boolean
  $carYearManufactured: Int
  $carModel: String
  $claimNumber: String
  $claimSettlementTypeId: String
  $clientName: String
  $clientPhone: String
  $clientType: String #person nebo company
  $clientIdentificationCode: String
  $dateOfLoss: Timestamp
  $damageNumber: String
  $description: String
  $externalCode: String
  $insuranceCompanyId: String
  $leasingApprovalNumber: String
  $note: String
  $partnerId: String!
  $serviceNumber: String
  ) {
    task{
      create(input: {
        damageCategoryId: $damageCategoryId
        damageTypeId: $damageTypeId
        carVin: $carVin
        carLicensePlate: $carLicensePlate
        carNonstandardLicensePlate: $carNonstandardLicensePlate
        carYearManufactured: $carYearManufactured
        carModel: $carModel
        claimNumber: $claimNumber
        claimSettlementTypeId: $claimSettlementTypeId
        clientName: $clientName
        clientPhone: $clientPhone
        clientType: $clientType
        clientIdentificationCode: $clientIdentificationCode
        dateOfLoss: $dateOfLoss
        damageNumber: $damageNumber
        description: $description
        externalCode: $externalCode
        insuranceCompanyId: $insuranceCompanyId
        leasingApprovalNumber: $leasingApprovalNumber
        note: $note
        partnerId: $partnerId
        serviceNumber: $serviceNumber
      }) {
        output {
          ${taskServiceTypeDef}
        }
        errors {
          ${errorsTypeDef}
        }
      }
    }
  }`;

export default createMutation;
